$(document).ready(function() {		
    $('#currencySelector').click(function () {
        $('#currencyList').slideToggle('fast');
    });
    $('#currencyList a').on('click', function (e) {
        e.preventDefault();
        $.post(e.target.href, function (currency) {
            $('.initial-currency i').attr('class', 'icon-' + currency.code);
            $('.initial-currency span').text(currency.code);
        });
    });
    
    $('#toggle-menu').click(function(){
        $("#menu ul").toggleClass('active');
        return false;
    });
    
    $('#menu li a').click(function(){
        $("#menu ul").removeClass('active');
        return false;
    });    
    
    $('#menu').hcSticky({
        top: 0,
        bottomEnd: 100
    });
    
    //scroll on click
    $('#menu li a').click(function(){
        $("html,body").animate({ scrollTop: $($(this).attr('href')).offset().top-30 }, 600);
        
        $.waypoints('disable');
        var fLeft = $(this).parent().position().left;
        var fWidth = $(this).parent().width()/2;
        $('#plane').stop(true,true).animate({"width":fLeft+fWidth}, 600,function(){
            $.waypoints('enable');
        });            
        
        return false;
    });   
    
    //set position on load
  	if ($("#menu").length > 0){
    	var fLeft = $('#menu li').eq(0).position().left;
    	var fWidth = $('#menu li').eq(0).width()/2;
    }
      $('#plane').css({"width":fLeft+fWidth});
    
    //set plane position on scroll
    $('.el-menu').waypoint(function(direction) {
        var fLeft = $('#menu a[href$="#'+ $(this).attr('id') +'"]').parent().position().left;
        var fWidth = $('#menu a[href$="#'+ $(this).attr('id') +'"]').parent().width()/2;
        $('#plane').stop(true,true).animate({"width":fLeft+fWidth}, 600);              
    }, { offset: '10%' });  
    
    
    $('#steps-btns a').click(function(){
        $('#steps-btns a').removeClass('on');
        $(this).addClass('on');
        $('.step').removeClass('active');
        $('.step').eq( $(this).index() ).addClass('active');
        
        return false;
    });    
  
 
    
    $('.goto').click(function(){
        $("html,body").animate({ scrollTop: $($(this).attr('href')).offset().top-30 }, 600);
        return false;
    });  
    
    $('#list-drivers a').click(function(){
        $('#list-drivers a').removeClass('off');
        $(this).addClass('off');
        $('.driver').removeClass('active');
        $('.driver').eq( $(this).index() ).addClass('active');
        return false;
    });     
    
    $('.btn-coupon').click(function(){
        $('#coupon-field').slideToggle();
        return false;
    });     
    
    $('.select-people a').click(function(){
        $('.select-people a').removeClass('on');
        $(this).addClass('on');
        $('#numofpeople').attr("value", $(this).data('val') );
        return false;
    }); 
  
  
  
  //Datepicker Handler//

  $('#button-pickup').click(function(){
  	$('#form-row-arrival input').attr('required',true);
    $('#form-row-arrival select').attr('required',true);
    $('#form-row-departure input').attr('required',false);
    $('#form-row-departure select').attr('required',false);
    
  });
  
  $('#button-pickup-and-dropoff').click(function(){  		
    $('#form-row-arrival input').attr('required',true);
    $('#form-row-arrival select').attr('required',true);
    $('#form-row-departure input').attr('required',true);
    $('#form-row-departure select').attr('required',true);
  });
  
  
  $('#button-dropoff').click(function(){  		
    $('#form-row-departure input').attr('required',true);
    $('#form-row-departure select').attr('required',true);
    $('#form-row-arrival input').attr('required',false);
    $('#form-row-arrival select').attr('required',false);
    $( "#booking-start-your-transfer-from-athens-airport-to-the-city" ).removeClass( "required" );
  });
  
  //End of Datepicker Handler//
  
    
    var flag = false;
    function carMove(){
        flag = true;
        $('#map .icon2').css({"left":100 });
        $('.tooltip1 p').html('“Oh I am so excited! I am finally in GREECE!!”');
        $('.tooltip2 p').html('“Nice to meet you Jane! ”');
        $('#map .icon2').animate({"left":220,"top":15},500,"linear",function(){
            $('#map .icon2').animate({"left":420,"top":10},700,"linear",function(){
                //step1
                $('.tooltip1, .tooltip2').addClass('anim');
                setTimeout(function() {
                    $('.tooltip1, .tooltip2').removeClass('anim');
                    $('.tooltip1 p').html('“What’s a nice<br/>place to eat downtown?”');
                    $('.tooltip2 p').html('“You should<br/>try Argos - Great view as well!”');
                }, 400);
                setTimeout(function() {
                    $('#map .icon2').animate({"left":540,"top":5},700,"linear",function(){
                        $('#map .icon2').animate({"left":750,"top":15},900,"linear",function(){
                            //step2
                            $('.tooltip1, .tooltip2').addClass('anim');
                            setTimeout(function() { 
                                $('.tooltip1, .tooltip2').removeClass('anim'); 
                                $('.tooltip1 p').html('“What about sightseeing after Acropolis?”');
                                $('.tooltip2 p').html('“I can suggest to you some great walks downtown.”');
                            }, 400);
                            setTimeout(function() {
                                $('#map .icon2').animate({"left":900,"top":-9},800,"linear",function(){
                                    $('#map .icon2').animate({"left":1150,"top":12},1100,"linear",function(){
                                        //change text
                                        $('.tooltip1, .tooltip2').addClass('anim');
                                        setTimeout(function() { 
                                            $('.tooltip1, .tooltip2').removeClass('anim'); 
                                            $('.tooltip1 p').html('“Thanks for the ride and all the information”');
                                            $('.tooltip2 p').html('“My pleasure. Text me if you need anything!”');
                                        }, 400);
                                        //in order to remove repeat remove self invoking func
                                        setTimeout(function() {
                                            carMove();
                                        }, 3000);
                                    });
                                });
                            }, 3000);
                        }); 
                    });
                }, 3000);
            });
        });
    }
    $('#intro').waypoint(function(direction) {
        if( flag == false && $(window).width() > 1160 )
            carMove();  
    }, { offset: '10%' });  
  
  	
	// weekly statistics section update from json file url
  	var jsonURL = "http://cdn.shopify.com/s/files/1/0516/1281/t/4/assets/wpickups_weekly_stats.json";
    var currentCity = "athens";

    $.ajax({
        url: jsonURL,
        dataType: "text",
        success: function(data) {
            var json = $.parseJSON(data);
            cityData = json[currentCity];

            $(".people-stats .num .int").text(cityData.numberOfPeople);
            $(".countries-stats .num .int").text(cityData.numberOfCountries);

            $(".people-stats .tags").empty();
            for(var i = 0, maxPeople = cityData.people.length; i < maxPeople; i++){
                $(".people-stats .tags").append("<span>"+cityData.people[i]+"</span>");
            }

            $(".countries-stats .tags").empty();
            for(var i = 0, maxCountries = cityData.countries.length; i < maxCountries; i++){
                $(".countries-stats .tags").append("<span>"+cityData.countries[i]+"</span>");
            }
        
       	 	console.log("Weekly stats updated!");

        },
        error: function(){
            console.log("Unable to retrieve json from "+jsonURL);
        }
    });
  
    
    
});